<template>
	<div class="container">
		<h1>{{$t('room.lobby')}}</h1>
		<div class="info" v-if="this.case">
			<content-card :title="this.case.title" :media="this.caseImage" :clickable="false" :mediaRaw="true" />
			<!-- <p>{{$t('room.pageType')}}:
				<b class="capitalized" v-if="pageType != 'unset'">{{$t(`room.${pageType}`)}}</b>
				<b class="capitalized" v-else>?</b>
			</p> -->
		</div>
		<div v-if="pageType == 'roleplay'">
			<app-button class="mb-4" v-on:onClick="startRoleplay">{{$t('misc.start')}}</app-button>
		</div>
		<div v-else>
			<h2>{{$t('room.waiting')}}..</h2>
		</div>
		<app-button buttonStyle="secondary" v-on:onClick="leaveRoom">{{$t('misc.quit')}}</app-button>
	</div>
</template>

<script>
	import {$eBus} from '@/event-bus';
	import GameClientEvent from '@/enum/GameClientEvent';
	import GamePhase from '@/enum/GamePhase';
	import {getStudentUrl} from '@/utils/UrlUtil'
	import * as MutationTypes from '@/store/mutation-types';
	import AppButton from '@/components/app-button';
	import MediaManager from '@/media-manager';
	import ContentCard from "@/components/content-card/index";

	export default {
		components: {
			ContentCard,
			AppButton
		},
		data() {
			return {
				dataLoaded: false,
				pageType: '',
				case: null,
				theme: null,
				pages: {
					dilemma: [],
					roleplay: []
				}
			}
		},
		mounted() {
			if (this.$gameClient == null || !this.$gameClient.isConnected || !this.$gameClient.inRoom()) {
				this.$router.push(getStudentUrl('connect'));
				return;
			}

			$eBus.$on(GameClientEvent.RoomStateChange, this.onRoomStateChanged);
			$eBus.$on(GameClientEvent.PhaseChanged, this.onPhaseChanged);

			this.$store.commit(MutationTypes.SET_GAME_CLIENT_CLOSE_REDIRECT_URL, getStudentUrl('connect'));

			if (this.$gameClient.room.state.selectedCaseId) {
				this.loadCase(this.$gameClient.room.state.selectedCaseId);
			}

			if (this.$gameClient.room.state.pageType) {
				this.setPageType(this.$gameClient.room.state.pageType);
			}
		},
		beforeDestroy() {
			$eBus.$off(GameClientEvent.RoomStateChange, this.onRoomStateChanged);
			$eBus.$off(GameClientEvent.PhaseChanged, this.onPhaseChanged);
		},
		computed: {
			caseImage() {
				return MediaManager.getMediaUrl(this.case.image);
			}
		},
		methods: {
			onRoomStateChanged(room, roomState) {
				if (!this.dataLoaded && roomState.selectedCaseId) {
					this.loadCase(roomState.selectedThemeId, roomState.selectedCaseId);
				}

				if (roomState.pageType && this.pageType != roomState.pageType) {
					this.setPageType(roomState.pageType);
				}
			},
			onPhaseChanged(newPhase) {
				if (this.dataLoaded && newPhase == GamePhase.Pages) {
					if (this.pageType == 'dilemma') {
						this.$router.push(getStudentUrl('game'));
					}
				}
			},
			loadCase(themeId, caseId) {
				this.dataLoaded = false;

				//this.$store.commit(MutationTypes.SET_CURRENT_THEME, theme)

				this.loadPages(themeId, caseId, () => {
					this.dataLoaded = true;
					if (this.pageType) {
						this.case.pages = this.pages[this.pageType];
						this.$store.commit(MutationTypes.SET_CURRENT_CASE, this.case);
						this.onPhaseChanged(this.$gameClient.room.state.phase);
					}
				});
			},
			loadPages(themeId, caseId, callback) {
				this.dataLoaded = false;

				this.$apiClient.getTheme(themeId, (_theme) => {
					this.theme = _theme;

					console.log('Theme:', _theme);
					this.$store.commit(MutationTypes.SET_CURRENT_THEME, _theme);

					this.$apiClient.getCase(caseId, (_case) => {
						this.case = _case;
						this.$apiClient.getCasePages(caseId, 'dilemma', (pages) => {
							this.pages.dilemma = pages;
							this.$apiClient.getCasePages(caseId, 'roleplay', (pages) => {
								this.pages.roleplay = pages;
								callback();
							});
						});
					});
				});
			},
			setPageType(pageType) {
				this.pageType = pageType;
				if (this.dataLoaded) {
					this.case.pages = this.pages[pageType];
				}
				this.$store.commit(MutationTypes.SET_CURRENT_CASE, this.case);
			},
			startRoleplay() {
				this.$store.commit(MutationTypes.SET_GAME_CLIENT_CLOSE_REDIRECT_URL, getStudentUrl('lobby'));
				this.$store.commit(MutationTypes.SET_CURRENT_PAGE_INDEX, 0);
				this.$router.push(getStudentUrl('roleplay'));
			},
			leaveRoom() {
				this.$store.commit(MutationTypes.SET_LAST_EMOJI_CODE, null);
				this.$gameClient.leaveRoom();
			}
		}
	}
</script>

<style lang="less" scoped>
	.info {
		margin: 0px auto 50px auto;
	}

	.case-image {
		max-height: 128px;
		width: auto;
		margin-bottom: 10px;
	}

	.capitalized {
		text-transform: capitalize;
	}
</style>
